import './_Header.scss';
import { Button, Layout, Switch } from '@arkas/coreui';
import AppHeaderButtons from './HeaderButtons';
import AppHeaderTitle from './HeaderTitle';
import { applicationState } from '@/states/applicationState';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';

const { Header } = Layout;

interface AppHeaderProps {
  topMenu: boolean;
  collapseSider: boolean;
  isSmallScreen: boolean;
  toggleSider: Function;
  switchMenu: (checked: boolean) => void;
  switchTheme: (checked: boolean) => void;
}

interface AppHeaderStates {}

/**
 * AppHeader Component
 */
class AppHeader extends React.Component<AppHeaderProps, AppHeaderStates> {
  toggleSiderWithSwitch = (isChecked: boolean) => {
    const { toggleSider } = this.props;
    toggleSider(!isChecked);
  };

  toggleSiderWithButton = () => {
    const { toggleSider } = this.props;
    toggleSider(false);
  };

  render() {
    const {
      topMenu,
      collapseSider,
      isSmallScreen,
      switchMenu,
      switchTheme
    } = this.props;
    return (
      <Header
        className={classnames(
          'app-header',
          isSmallScreen && 'mobile',
          topMenu
            ? 'has-top-menu'
            : !isSmallScreen &&
              (collapseSider ? 'has-collapsed-sider' : 'has-full-sider')
        )}
      >
        {isSmallScreen ? (
          <div className="app-header-mobile-logo-title">
            <div className="sider-toggler">
              <Button
                ghost={true}
                className="sider-toggle-button"
                icon="menu-unfold"
                onClick={this.toggleSiderWithButton}
              />
            </div>
            <AppHeaderTitle />
          </div>
        ) : topMenu ? (
          <div>
            <AppHeaderTitle />
          </div>
        ) : (
          <div className="sider-toggle-switch">
            <Switch
              size={'small'}
              onChange={this.toggleSiderWithSwitch}
              checked={!collapseSider}
            />
          </div>
        )}
        <AppHeaderButtons switchMenu={switchMenu} switchTheme={switchTheme} />
      </Header>
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    topMenu: state.appModel.topMenu
  };
};
export default connect(mapStateToProps)(AppHeader);
